import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/juro/projects/open-a11y/research/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <blockquote>
      <p parentName="blockquote">{`This project is in its infancy. Expect rapid iteration and high-flux while we flesh out the mission and process.`}</p>
      <p parentName="blockquote">{`Thanks!`}</p>
    </blockquote>
    <h1>{`Vision`}</h1>
    <p>{`The web deserves interoperability between component frameworks and design systems.
The UI community is in a similar place as the industrial revolution prior to standardization.
Untold amounts of human effort are exhausted globally every day on rebuilding identical components for web apps.`}</p>
    <p>{`This should not be the case.
The UI community should standardize namings and structures for common components.
We should also standardize a way of theming these components.
We should set a path for existing solutions to converge and for browser to natively provide these things in the future.`}</p>
    <p>{`UI component patterns have evolved and stabilized but have not made their way to browsers or standards.
Designers and developers reinvent the same components for every product they build.
When building a web app or web page designers and developers should have a common set of components at their disposal.
We shouldn't have to rebuild a dropdown, modal dialog, split button, or other components before we build our products.`}</p>
    <p>{`For complete outline of goals and process view our `}<a parentName="p" {...{
        "href": "./charter"
      }}>{`full charter`}</a>{`.`}</p>
    <h2>{`Goals for web specifications`}</h2>
    <p>{`For web app component specifications here are the specific goals:`}</p>
    <ul>
      <li parentName="ul">{`Standardize on the names of the component parts and anatomy structure`}</li>
      <li parentName="ul">{`Standardize the name of states which are applicable to the component and its parts`}</li>
      <li parentName="ul">{`Standardize the behaviors of components`}</li>
      <li parentName="ul">{`Update other specifications in other standards bodies when gaps are discovered (eg: If
discover the need for a new HTML element or CSS property, propose and have it standardized in
the WHATWG HTML spec and CSSWG respectively)`}</li>
    </ul>
    <h2>{`Non-goals for web specifications`}</h2>
    <p>{`For web app component specifications here are specific non-goals:`}</p>
    <ul>
      <li parentName="ul">{`Standardize on the default appearance of a component for all implementations`}</li>
    </ul>
    <h1>{`Principles`}</h1>
    <p>{`These are the principles Open UI believes should be considered to realize the above goals.
As with all rules, there are always exceptions.`}</p>
    <h2>{`Naming`}</h2>
    <ul>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Descriptivism is superior to prescriptivism for finding names`}</strong></p>
        <p parentName="li"><strong parentName="p">{`Why?`}</strong>{`
Borrowing from `}<a parentName="p" {...{
            "href": "https://en.wikipedia.org/wiki/Linguistic_description"
          }}>{`linguistic analysis`}</a>{` we believe that objective analysis of existing words in use in the UI community at large will produce names that are most likely to be adopted by the broader web.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Names should be void of design information`}</strong></p>
        <p parentName="li"><strong parentName="p">{`Why?`}</strong>{`
When designs change names should not become invalid.
Names should stand the test of time.
Usually, names based on intent or usage are more robust and stand this test.
Consider a component that displays mock content while waiting for the actual content to load.
It might be more ideally named `}<inlineCode parentName="p">{`Placeholder`}</inlineCode>{` opposed to `}<inlineCode parentName="p">{`Shimmer`}</inlineCode>{`, even though most implementations appears to flash or shimmer.
When the design changes and these components no longer shimmer, the name will become invalid and not make sense.`}</p>
      </li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      